/*
  HOFFMANN 25.09.2026 – Eigener Einwilligungs-Manager, Teil 3 von 3 (Logik).
  Ersetzt die App Complianz/iubenda. Zusammenspiel:
  - snippets/hf-consent-head.liquid (erstes Skript im <head>) liest das Cookie
    hf_consent, setzt Consent Mode v2 und stellt window.HFConsent bereit.
  - snippets/hf-consent-banner.liquid liefert Banner und Dialog.
  - Diese Datei speichert die Entscheidung und gibt sie weiter:
      Shopify Customer Privacy API  -> steuert alle App-Pixel (Google & YouTube,
                                       Meta, Pinterest, Klaviyo) und den Checkout
      Google Consent Mode v2        -> gtag('consent','update') + Ereignis hf_consent_update
      Google Tag Manager            -> erst nach Statistik oder Marketing (Theme-Einstellung)
      Klaviyo Onsite (klaviyo.js)   -> erst nach Marketing
      <script type="text/plain" data-hf-consent="marketing"> im Theme -> wird aktiviert
  Kategorien: necessary (immer), preferences, analytics, marketing.
  Wird eine Einwilligung zurueckgenommen, laedt die Seite neu, weil schon
  geladene Skripte sich nicht entladen lassen.
*/
(function () {
  'use strict';

  var HF = (window.HFConsent = window.HFConsent || {});
  var COOKIE = 'hf_consent';
  var MAX_AGE = 60 * 60 * 24 * 365;
  var CATS = ['preferences', 'analytics', 'marketing'];
  var COOKIES_BY_CAT = {
    analytics: [/^_ga/, /^_gid$/, /^_gat/],
    marketing: [/^_gcl_/, /^_fbp$/, /^_fbc$/, /^_pin_unauth$/, /^_pinterest_/, /^__kla_id$/]
  };

  var bar = document.getElementById('hfc-banner');
  var dialog = document.getElementById('hfc-dialog');
  var status = document.getElementById('hfc-status');
  var lastFocus = null;

  function yn(b) { return b ? 'yes' : 'no'; }

  /* ---------- Speichern ---------- */

  function writeCookie(state) {
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(state)) +
      '; Max-Age=' + MAX_AGE + '; Path=/; SameSite=Lax' + secure;
  }

  function removeCookies(cat) {
    var host = location.hostname;
    var domains = ['', host, '.' + host, '.' + host.replace(/^www\./, '')];
    document.cookie.split(';').forEach(function (part) {
      var name = part.split('=')[0].trim();
      if (!COOKIES_BY_CAT[cat].some(function (re) { return re.test(name); })) return;
      domains.forEach(function (dom) {
        document.cookie = name + '=; Max-Age=0; Path=/' + (dom ? '; Domain=' + dom : '');
      });
    });
  }

  /* ---------- Weitergabe ---------- */

  function withPrivacyApi(cb) {
    var sh = window.Shopify;
    if (sh && sh.customerPrivacy && sh.customerPrivacy.setTrackingConsent) return cb(sh.customerPrivacy);
    if (sh && typeof sh.loadFeatures === 'function') {
      sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err && window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
      });
    }
  }

  function syncShopify(state) {
    withPrivacyApi(function (api) {
      api.setTrackingConsent({
        analytics: state.analytics,
        marketing: state.marketing,
        preferences: state.preferences,
        sale_of_data: state.marketing
      }, function () {});
    });
  }

  function loadKlaviyo() {
    if (HF.klaviyoLoaded || !HF.klaviyoId) return;
    HF.klaviyoLoaded = true;
    var id = encodeURIComponent(HF.klaviyoId);
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://static.klaviyo.com/onsite/js/' + id + '/klaviyo.js?company_id=' + id;
    document.head.appendChild(s);
  }

  function activateScripts(state) {
    var held = document.querySelectorAll('script[type="text/plain"][data-hf-consent]');
    Array.prototype.forEach.call(held, function (old) {
      var need = old.getAttribute('data-hf-consent').split(/\s+/);
      if (!need.every(function (c) { return state[c]; })) return;
      var s = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (a) {
        if (a.name === 'type' || a.name === 'data-hf-consent') return;
        s.setAttribute(a.name === 'data-src' ? 'src' : a.name, a.value);
      });
      if (!old.hasAttribute('data-src')) s.text = old.text;
      old.parentNode.replaceChild(s, old);
    });
  }

  function apply(state) {
    HF.state = state;
    window.gtag('consent', 'update', HF.googleConsent(state));
    window.dataLayer.push({
      event: 'hf_consent_update',
      hf_consent: { preferences: state.preferences, analytics: state.analytics, marketing: state.marketing }
    });
    if (state.analytics || state.marketing) HF.loadGtm();
    if (state.marketing) loadKlaviyo();
    activateScripts(state);
    document.documentElement.classList.remove('hfc-pending');
    window.dispatchEvent(new CustomEvent('hf:consent', { detail: state }));
  }

  function decide(choice) {
    var prev = HF.state;
    var state = { v: HF.version, t: Date.now(), necessary: true };
    CATS.forEach(function (c) { state[c] = !!choice[c]; });

    var withdrawn = !!prev && CATS.some(function (c) { return prev[c] && !state[c]; });
    Object.keys(COOKIES_BY_CAT).forEach(function (c) { if (!state[c]) removeCookies(c); });

    writeCookie(state);
    syncShopify(state);
    apply(state);
    hideBar();
    closeDialog();
    if (status) status.textContent = status.getAttribute('data-saved') || '';

    /* Kurz warten, damit Shopify die Ablehnung speichert, dann neu laden */
    if (withdrawn) setTimeout(function () { location.reload(); }, 400);
  }

  /* ---------- Oberflaeche ---------- */

  function showBar() { if (bar) bar.hidden = false; }
  function hideBar() { if (bar) bar.hidden = true; }

  function fillSwitches() {
    var s = HF.state || {};
    Array.prototype.forEach.call(dialog.querySelectorAll('[data-hfc-cat]'), function (input) {
      input.checked = !!s[input.getAttribute('data-hfc-cat')];
    });
  }

  function readSwitches() {
    var choice = {};
    Array.prototype.forEach.call(dialog.querySelectorAll('[data-hfc-cat]'), function (input) {
      choice[input.getAttribute('data-hfc-cat')] = input.checked;
    });
    return choice;
  }

  function openDialog() {
    if (!dialog) return;
    lastFocus = document.activeElement;
    fillSwitches();
    document.documentElement.classList.add('hfc-lock');
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closeDialog() {
    if (!dialog || !dialog.hasAttribute('open')) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function all(value) {
    var choice = {};
    CATS.forEach(function (c) { choice[c] = value; });
    return choice;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hfc], [data-hfc-open], a[href$="#cookie-einstellungen"], a[href$="#cookie-settings"]');
    if (!t) return;
    var action = t.getAttribute('data-hfc') || 'open';
    if (t.tagName === 'A') e.preventDefault();
    if (action === 'open') openDialog();
    else if (action === 'close') closeDialog();
    else if (action === 'accept') decide(all(true));
    else if (action === 'reject') decide(all(false));
    else if (action === 'save') decide(readSwitches());
  });

  if (dialog) {
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('hfc-lock');
      if (!HF.state) showBar();
      if (lastFocus && document.contains(lastFocus) && lastFocus.offsetParent !== null) lastFocus.focus();
    });
    /* Klick auf den abgedunkelten Hintergrund schliesst den Dialog */
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog();
    });
  }

  /* ---------- Start ---------- */

  HF.open = openDialog;
  HF.get = function () { return HF.state; };

  if (HF.state) {
    apply(HF.state);
    /* Shopify angleichen, falls dort nichts oder etwas anderes gespeichert ist */
    withPrivacyApi(function (api) {
      var c = api.currentVisitorConsent ? api.currentVisitorConsent() : null;
      var s = HF.state;
      if (!c || c.analytics !== yn(s.analytics) || c.marketing !== yn(s.marketing) || c.preferences !== yn(s.preferences)) {
        syncShopify(s);
      }
    });
  } else {
    /* Keine gueltige Auswahl (erster Besuch, abgelaufen, neue Version oder noch
       aus iubenda-Zeiten): Shopify auf "nein" setzen, damit keine Pixel laufen,
       solange der Banner fragt. Shopify speichert seine Zustimmung in einem
       eigenen, per JS nicht lesbaren Cookie, deshalb der Abgleich ueber die API. */
    withPrivacyApi(function (api) {
      var c = (api.currentVisitorConsent && api.currentVisitorConsent()) || {};
      if (c.analytics === 'yes' || c.marketing === 'yes' || c.preferences === 'yes' || c.sale_of_data === 'yes') {
        api.setTrackingConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false }, function () {});
      }
    });
  }
})();
